import { Children, Fragment } from 'react';

import { Divider, DividerProps } from '../Divider';

export type DividedPageProps = React.HTMLAttributes<HTMLDivElement> & {
	children: React.ReactNode | React.ReactNode[];
	dividerProps?: DividerProps;
};

export const DividedPage: React.FC<DividedPageProps> = ({
	children,
	dividerProps,
	className,
	...props
}) => {
	let childArray: React.ReactNode[];

	if (Array.isArray(children)) {
		childArray = children;
	} else {
		childArray = Children.toArray(children);
	}

	const length = Children.count(children);

	return (
		<div
			className={`divided-page${className ? ` ${className}` : ''}`}
			{...props}
		>
			{childArray.map(
				(child, index) =>
					child && (
						<Fragment key={index}>
							{child}

							{index !== length - 1 && (
								<Divider key={index} {...dividerProps} />
							)}
						</Fragment>
					)
			)}
		</div>
	);
};
